"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Link = _interopRequireDefault(require("../Link"));
var _Title = _interopRequireDefault(require("../Title"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _paragraph = _interopRequireDefault(require("./paragraph.proptypes"));
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ParagraphContainer = _styledComponents.default.div.withConfig({
  displayName: "Paragraph__ParagraphContainer",
  componentId: "sc-1w77mdi-0"
})(function (_ref) {
  var theme = _ref.theme,
    type = _ref.type;
  return "\n    width: 100%;\n    overflow: hidden;\n    box-sizing: border-box;\n\n    ".concat(type === _constants.PARAGRAPH_TYPES.NORMAL ? "\n          p {\n            margin-bottom: ".concat(theme.space.medium, ";\n          }\n        ") : '', "\n  ");
});
var ParagraphList = _styledComponents.default.ul.withConfig({
  displayName: "Paragraph__ParagraphList",
  componentId: "sc-1w77mdi-1"
})(function (_ref2) {
  var hasBullet = _ref2.hasBullet,
    theme = _ref2.theme;
  return "\n    margin: 0;\n    ".concat(!hasBullet ? "\n          list-style: none;\n          padding: 0;\n        " : "\n          padding: 0 0 0 ".concat(theme.space.standard, ";\n        "), "\n  ");
});
var ParagraphTextContainer = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Paragraph__ParagraphTextContainer",
  componentId: "sc-1w77mdi-2"
})(["font-size:", ";"], function (_ref3) {
  var fontSize = _ref3.fontSize,
    theme = _ref3.theme;
  return theme.fontSize[fontSize];
});
var BulletItem = _styledComponents.default.li.withConfig({
  displayName: "Paragraph__BulletItem",
  componentId: "sc-1w77mdi-3"
})(["color:", ";"], function (_ref4) {
  var theme = _ref4.theme,
    color = _ref4.color;
  return theme.colors[color];
});
var IconItemWrapper = _styledComponents.default.div.withConfig({
  displayName: "Paragraph__IconItemWrapper",
  componentId: "sc-1w77mdi-4"
})(["display:flex;padding:", ";gap:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.micro;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.micro;
});
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "Paragraph__IconWrapper",
  componentId: "sc-1w77mdi-5"
})([""]);
var Paragraph = function Paragraph(props) {
  var title = props.title,
    type = props.type,
    data = props.data,
    textAlign = props.textAlign,
    theme = props.theme,
    accessible = props.accessible,
    customProperties = props.customProperties,
    color = props.color,
    fontSize = props.fontSize,
    viewport = props.viewport,
    isChinaDomain = props.isChinaDomain,
    titleType = props.titleType,
    titleMargin = props.titleMargin,
    titleAlign = props.titleAlign,
    titleColor = props.titleColor,
    bulletColor = props.bulletColor;
  var paragraphs = data.find(function (d) {
    return d.paragraph;
  });
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var constructTextWithLink = function constructTextWithLink(textString, linkListNode, chinaDomain, parentIndex) {
    if (linkListNode) {
      var text = textString;
      var finalSubText = [];
      linkListNode.forEach(function (linkNode, index) {
        var splitText = text.split("{".concat(index, "}"));
        var _splitText = (0, _slicedToArray2.default)(splitText, 2),
          leftString = _splitText[0],
          rightString = _splitText[1];
        finalSubText.push(leftString);
        text = rightString;
        finalSubText.push( /*#__PURE__*/_react.default.createElement(_Link.default, {
          href: linkNode.url,
          size: fontSize,
          accessible: accessible,
          idConfig: {
            parentName: 'paragraph',
            index: "".concat(parentIndex).concat(index)
          },
          theme: theme
        }, linkNode.text));
      });
      return finalSubText;
    }
    return textString;
  };
  var renderIcon = function renderIcon(pData) {
    return /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      theme: theme,
      color: pData.iconColor,
      fontsize: 'normal',
      icon: pData.icon
    });
  };
  var renderParagraph = function renderParagraph(paragraphData, otherData) {
    var paragraphsArray = [];
    paragraphData.forEach(function (pData, index) {
      var linkObject = otherData.find(function (d) {
        return d[pData.id];
      });
      var linkItem = linkObject && linkObject[pData.id];
      var paragraphItem = /*#__PURE__*/_react.default.createElement(ParagraphTextContainer, {
        key: pData.text,
        color: color,
        fontSize: fontSize,
        viewport: viewport,
        display: "block",
        accessible: accessible,
        textAlign: textAlign
      }, constructTextWithLink(pData.text, linkItem, isChinaDomain, index));
      if (type === _constants.PARAGRAPH_TYPES.BULLET || type === _constants.PARAGRAPH_TYPES.LIST) {
        paragraphsArray.push( /*#__PURE__*/_react.default.createElement(BulletItem, {
          key: "paragraph-item-".concat(pData.text),
          color: bulletColor
        }, paragraphItem));
      } else if (type === _constants.PARAGRAPH_TYPES.ICON) {
        paragraphsArray.push( /*#__PURE__*/_react.default.createElement(IconItemWrapper, null, /*#__PURE__*/_react.default.createElement(IconWrapper, null, " ", renderIcon(pData)), paragraphItem));
      } else {
        paragraphsArray.push(paragraphItem);
      }
    });
    return paragraphsArray;
  };
  var renderParagraphByType = function renderParagraphByType(paragraphObject, otherData) {
    var paragraph = paragraphObject.paragraph;
    switch (type) {
      case _constants.PARAGRAPH_TYPES.BULLET:
        return /*#__PURE__*/_react.default.createElement(ParagraphList, {
          hasBullet: true
        }, renderParagraph(paragraph, otherData));
      case _constants.PARAGRAPH_TYPES.LIST:
      case _constants.PARAGRAPH_TYPES.ICON:
        return /*#__PURE__*/_react.default.createElement(ParagraphList, null, renderParagraph(paragraph, otherData));
      default:
        return renderParagraph(paragraph, otherData);
    }
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ParagraphContainer, (0, _extends2.default)({
      type: type
    }, customProperties), title && /*#__PURE__*/_react.default.createElement(_Title.default, {
      type: titleType,
      marginBottom: titleMargin,
      theme: theme,
      color: titleColor,
      accessible: accessible,
      textAlign: titleAlign
    }, title), renderParagraphByType(paragraphs, data));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Paragraph.propTypes = _paragraph.default.PropTypes;
Paragraph.defaultProps = _paragraph.default.DefaultProps;
var _default = Paragraph;
exports.default = _default;